// src/pages/CourseTime/components/activities/DiscussionActivity.comp.jsx
import React from 'react';
import * as S from '../../styles';
import { GET_APP_LOCALIZE_TEXT } from '../../../../utils/dq_lc_service/lc_service';
import { renderPlainTextWithFormatting } from '../../utils';


const DiscussionActivity = ({
  slide,
  onDiscussionStart,
  interactionLoading,
  fetchingExistingRecord,
  inputsDisabled,
  activityCompleted,
  themeColor,
  pageLc
}) => {
  const renderHtmlContent = (content) => {
    if (!content) return null;
    const text = String(content).trim();
    const hasHtml = /<[^>]+>/.test(text);
    return hasHtml
      ? <span dangerouslySetInnerHTML={{ __html: text }} />
      : renderPlainTextWithFormatting(text);
  };

  return (
    <S.ActivityWrapper>
      <S.ActivityColumnContainer>
        {/* Header */}
        <S.ActivityHeader>
          <S.ActivityPill>{GET_APP_LOCALIZE_TEXT(pageLc, 'ct__discussion_time')}!</S.ActivityPill>
          <S.ActivityTitle>{renderHtmlContent(slide.SlideTitle)}</S.ActivityTitle>
          <S.ActivityContent>{renderHtmlContent(slide.SlideContent)}</S.ActivityContent>
        </S.ActivityHeader>

        {/* Discussion Button */}
        <S.DiscussionButton
          onClick={() => onDiscussionStart(slide)}
          disabled={interactionLoading || fetchingExistingRecord}
          themeColor={themeColor}
        >
          {interactionLoading
            ? GET_APP_LOCALIZE_TEXT(pageLc, 'ct__starting_discussion') + '...'
            : GET_APP_LOCALIZE_TEXT(pageLc, 'ct__lets_talk_about_it')}
        </S.DiscussionButton>
        
        {/* Completion indicator */}
        {activityCompleted[slide.SlideID] && (
          <S.ResponseSavedWrapper>
            <S.ResponseSavedIndicator>
              <i className="fa fa-comments" style={{ color: "#fff", marginRight: "6px" }} />
              {GET_APP_LOCALIZE_TEXT(pageLc, 'ct__discussion_started')}
            </S.ResponseSavedIndicator>
          </S.ResponseSavedWrapper>
        )}
      </S.ActivityColumnContainer>

      {/* Loading overlay */}
      {(fetchingExistingRecord || interactionLoading) && (
        <S.ActivityLoadingOverlay>
          <S.LoadingSpinner />
          <S.LoadingText>
            {fetchingExistingRecord ? GET_APP_LOCALIZE_TEXT(pageLc, 'ct__loading_existing_record') + '...' : GET_APP_LOCALIZE_TEXT(pageLc, 'ct__starting_discussion') + '...'}
          </S.LoadingText>
        </S.ActivityLoadingOverlay>
      )}
    </S.ActivityWrapper>
  );
};

export default DiscussionActivity;
